import axios from 'axios'
import VueAxios from 'vue-axios'
import pathAxios from "@/plugins/patchAxios";
//'https://server.tender-yaratelle.ru' //window.location.hostname === 'localhost' || window.location.hostname === '192.168.1.18' ? 'http://localhost:8888' : 'https://server.tender-yaratelle.ru'

axios.defaults.baseURL = pathAxios;

export default { VueAxios, axios }
